import gql from 'graphql-tag';
import { Fragments } from '@shared/api/fragments';

export const updateNotificationPreference = gql`
  mutation UpdateNotificationPreferenceMutation($input: UpdateNotificationPreference!) {
    updateNotificationPreference(input: $input) {
      ...NotificationPreference
    }
  }

  ${Fragments.notifications.notificationPreference}
`;

export const removeNotificationPreference = gql`
  mutation DeleteNotificationPreferenceMutation($input: DeleteNotificationPreferenceInput!) {
    deleteNotificationPreference(input: $input)
  }
`;
